'use client';

import React from 'react';
import { MOCK_CYCLES, MOCK_ACTIVITIES } from '@/data/mockData';
import CycleHealthTable from './CycleHealthTable';
import ActivityFeed from './ActivityFeed';

export default function DashboardBottom() {
  const activeCycles = MOCK_CYCLES?.filter((c) =>
    ['active', 'in-progress', 'under-review', 'hr-review', 'published']?.includes(c?.status)
  );

  return (
    <div className="pn-appraisal__dashboard-bottom">
      <CycleHealthTable cycles={activeCycles} />
      <ActivityFeed activities={MOCK_ACTIVITIES} />
    </div>
  );
}